<template>
  <section class="icons content-padd" :class="{ isMobile }">
    <div class="content-width">
      <h2 class="title-underline icons-title">
        Dlaczego warto korzystać z narzędzi cyfrowych?
      </h2>
      <div class="icons-cont">
        <LibHomeSectionIcon icon="home-icon-1.svg" title="Pewność">
          Otrzymujesz potwierdzenia złożenia dokumentów i{{ "\xa0" }}możesz
          śledzić statusy postępowań.
        </LibHomeSectionIcon>
        <LibHomeSectionIcon icon="home-icon-2.svg" title="Wygoda">
          Załatwiasz sprawy wygodnie, o{{ "\xa0" }}dowolnej porze i{{
            "\xa0"
          }}bez wychodzenia z{{ "\xa0" }}domu.
        </LibHomeSectionIcon>
        <LibHomeSectionIcon icon="home-icon-3.svg" title="Oszczędność">
          Nie tracisz czasu i{{ "\xa0" }}ograniczasz koszty swojej działalności.
        </LibHomeSectionIcon>
        <LibHomeSectionIcon icon="home-icon-4.svg" title="Bezpieczeństwo">
          Masz zapewnione standardy bezpieczeństwa dla usług publicznych.
        </LibHomeSectionIcon>
      </div>
    </div>
  </section>
</template>
<script>
import LibHomeSectionIcon from "./LibHomeSectionIcon.vue";
export default {
  name: "LibHomeSectionIcons",
  components: { LibHomeSectionIcon }
};
</script>

<style scoped>
.icons {
  position: relative;
  background: #f0f6ff;
}
.icons-title {
  color: var(--c-primary);
  margin-bottom: clamp(60px, 6vw, 100px);
}

.icons-cont {
  display: grid;
  grid-gap: 40px 10px;
  /* grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); */
  grid-template-columns: repeat(4, 1fr);
}

.isMobile {
  .icons-cont {
    grid-template-columns: repeat(2, 1fr);
  }
  .icon-text {
    font-size: 14px;
  }
}
</style>
